var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarAmy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "avatar-amy_svg__a",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "avatar-amy_svg__f",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8%",
    y: "-4.9%",
    width: "116%",
    height: "109.8%",
    filterUnits: "objectBoundingBox",
    id: "avatar-amy_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.249480988 0",
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "avatar-amy_svg__d",
    d: "M0 .133h1.305v.884H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar-amy_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar-amy_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0E3E4",
    xlinkHref: "#avatar-amy_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#avatar-amy_svg__b)",
    mask: "url(#avatar-amy_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.43 5.727c-7.387 0-13.375 5.988-13.375 13.375v28.963h26.75V19.102c0-7.387-5.988-13.375-13.375-13.375",
    fill: "#663537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.227 11.035c4.737-4.69 12.324-1.958 14.469-2.739.408-.148-.686-.795-.686-.795a13.308 13.308 0 00-6.613-1.751c-7.387 0-13.376 5.988-13.376 13.375v28.962H21.3V23.943c0-6.847.875-9.884 3.928-12.908",
    fill: "#C37C4F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.108 7.367)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar-amy_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar-amy_svg__d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.305.73C.997.516.678.32.352.132L0 1.017C.518.947.96.855 1.305.73",
    fill: "#485AA7",
    mask: "url(#avatar-amy_svg__e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.53 87.124h40.92l1.794-27.826a21.12 21.12 0 00-.045-3.49c-.905-8.953-12.09-12.872-17.64-12.872h-9.137c-5.55 0-16.735 3.92-17.64 12.873a21.166 21.166 0 00-.045 3.489l1.794 27.826z",
    fill: "#B42C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.959 24.334c-1.084.625-.736 1.798-1.628 2.155a5.032 5.032 0 00-.482-2.026c-1.327-2.842-5.148-4.574-8.237-5.306-3.765-.892-6.34-4.756-6.34-4.756s-1.646 1.383-3.06 4.064c-1.266 2.403-1.886 5.093-1.886 7.808v3.962c0 3.89 2.215 7.258 5.451 8.92l-.053 1.651c-.033 1.003-.479 1.97-1.28 2.574-.848.638-1.347 1.793-1.347 3.865 0 5.28 3.239 9.56 7.234 9.56 3.996 0 7.235-4.28 7.235-9.56 0-2.072-.5-3.227-1.347-3.865-.802-.604-1.247-1.57-1.28-2.574l-.053-1.632a10.023 10.023 0 005.464-8.271c1-.083 1.852-.833 2.019-1.868l.4-2.478c.134-.838-.17-1.695-.81-2.223",
    fill: "#FFE0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.959 24.334c-1.084.625-.736 1.798-1.628 2.155a5.032 5.032 0 00-.482-2.026 6.244 6.244 0 00-1.01-1.506c.003 1.227.014 2.2.014 3.194 0 5.147-1.86 13.506-8.639 14.064-2.308.19-3.76-.628-4.437-1.06l-.053 1.651a3.61 3.61 0 01-.113.778c1.049.905 4.75 3.525 9.615.506a3.565 3.565 0 01-.287-1.284l-.053-1.632a10.023 10.023 0 005.464-8.271c1-.083 1.852-.833 2.019-1.868l.4-2.478c.134-.838-.17-1.695-.81-2.223M27.667 17.076c2.604 3.582 6.775 2.218 11.628 4.524-1.689-1.195-3.819-2.001-5.683-2.443-3.765-.892-6.34-4.756-6.34-4.756s-1.646 1.383-3.06 4.064a16.532 16.532 0 00-1.825 6.35c.768-2.855 2.306-6.494 5.28-7.739",
    fill: "#F2B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.841 24.263l-.135 1.951a1.386 1.386 0 01-1.378 1.286h-4.095c-.679 0-1.252-.487-1.363-1.157l-.32-1.95a1.378 1.378 0 011.362-1.606h4.552c.386 0 .745.155 1.01.438.263.283.394.652.367 1.038m-9.87.13l-.322 1.95a1.376 1.376 0 01-1.363 1.157H25.19a1.385 1.385 0 01-1.378-1.286l-.135-1.95a1.367 1.367 0 01.368-1.039 1.366 1.366 0 011.01-.438h4.551a1.38 1.38 0 011.363 1.605m9.955-1.588a2.006 2.006 0 00-1.461-.635h-4.552a1.996 1.996 0 00-1.997 1.92 6.096 6.096 0 00-1.311 0 1.994 1.994 0 00-1.997-1.92h-4.551c-.553 0-1.085.231-1.462.635-.377.403-.57.951-.533 1.502l.136 1.951a2.005 2.005 0 001.994 1.86h4.095c.983 0 1.813-.703 1.973-1.673l.284-1.725a5.477 5.477 0 011.433 0l.284 1.725c.16.97.99 1.674 1.973 1.674h4.095a2.005 2.005 0 001.994-1.86l.136-1.952a2.006 2.006 0 00-.533-1.502",
    fill: "#8D5E3F"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  }))));
}

export default SvgAvatarAmy;